import React, { useEffect, useState } from 'react'
import { Delete_Price_Api, GetAll_Paging_Price_Api } from '../../API/PriceApi';
import { Button, Col, Layout, Modal, Pagination, Row } from 'antd';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import { CloseOutlined, DeleteOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
// ======================================================================
export const AllPriceComponent = ({ setLoading, showMessage, categoryId, categoryTitle, version, currentPage, setCurrentPage, onAddClick, onClickItem, onBackClick, onEdit, onRowDeleted }) => {
    // ======================================================================
    const [prices, setPrices] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [currentPage, version]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_Price_Api({ pageNumber: currentPage, categroryId: categoryId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setPrices(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        setLoading(true);
        try {
            let data = await Delete_Price_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                    <Button onClick={() => onBackClick()}>
                        <DoubleRightOutlined />
                        بازگشت
                    </Button>
                </Col>
                <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                    <h2 >
                        قیمت گذاری  {categoryTitle}
                    </h2>
                </Col>
                <Col xs={8} sm={8} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                    <Button className='btn-primary' onClick={() => onAddClick()} >
                        <PlusOutlined />
                        ایجاد رکورد جدید</Button>
                </Col>
            </Row>
            <div className='container'>

                {prices.map((price, key) =>
                    <>
                        <Row key={key} className="valueRow">
                            <Col span={15} onClick={() => { if (onClickItem) onClickItem(price.id) }} style={{ padding: "5px" }}>  {price.title} </Col>
                            <Col span={9} style={{ textAlign: "left" }}>
                                <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(price.id)}>
                                    <EditOutlined />
                                    ویرایش
                                </Button>
                                <Button
                                    className='btn-danger'
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از حذف ' + price.title + ' اطمینان دارید؟',
                                            onOk: () => { deleteRow(price.id) },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <DeleteOutlined />
                                    حذف</Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
            <ConfigProvider direction="rtl" locale={faIR}>
                <Pagination current={currentPage}
                    showSizeChanger={false}
                    showQuickJumper={false}
                    align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
            </ConfigProvider>
        </>

    )
}